import { FC } from 'react';
import { RecognitionsLayout } from 'pages/atoms';
import { RecognitionsSettings } from 'containers/recognitions';

const RecognitionsSettingsPage: FC = () => {
  return (
    <RecognitionsLayout>
      <RecognitionsSettings />
    </RecognitionsLayout>
  );
};

export default RecognitionsSettingsPage;
